import {ROUTE_RULES} from "~/routes/route-rules";
import {PERMISSION_STATE} from "~/states/state";

export default defineNuxtRouteMiddleware(async (to, from) => {
    if (!to) return

    const {isUserLogged} = useUserSession()
    const logged = await isUserLogged()

    if (to.name !== 'login' && !logged ) {
        return navigateTo('/login')
    }

    const permission = useState<any>(PERMISSION_STATE)

    // if (to?.fullPath && to.fullPath in ROUTE_RULES) {
    //     const res = permission.value.includes(ROUTE_RULES[to.fullPath as keyof typeof ROUTE_RULES])
    //
    //     if(!res) return navigateTo('/login')
    // }

    if (to.fullPath == '/') {
        const cfg = useRuntimeConfig()
        return navigateTo(cfg.public.defaultPage)
    }
})
